import { FieldValues } from "react-hook-form";
import { FormProvider } from "./FormProvider";
import { FormProps } from "./types";
import { Button } from "./parts/Button";
import { Input } from "./parts/Input";
import { Combobox } from "./parts/Combobox";
import { RadioGroup } from "./parts/RadioGroup";
import { RadioGroupItem } from "../RadioGroup";
import { Divider } from "./parts/Divider";
import { Title } from "./parts/Title";
import { Group } from "./parts/Group";
import { Textarea } from "./parts/Textarea";
import { cn } from "../../utils";
import { TagsInput } from "./parts/TagsInput";
import { Select } from "./parts/Select";
import { CheckboxGroup } from "./parts/CheckboxGroup";
import { Checkbox } from "../CheckboxGroup";

export const Form = <T extends FieldValues>(props: FormProps<T>) => {
  const {
    className: propsClassName,
    disabled = false,
    readOnly = false,
    methods,
    onSubmit = () => {},
    ...rest
  } = props;

  const { handleSubmit } = methods;

  const className = cn("qodo qodo-form", "flex flex-col gap-6", propsClassName);

  return (
    <FormProvider methods={methods} disabled={disabled} readOnly={readOnly}>
      <form className={className} onSubmit={handleSubmit(onSubmit)} {...rest} />
    </FormProvider>
  );
};

Form.Button = Button;
Form.Input = Input;
Form.Select = Select;
Form.Combobox = Combobox;
Form.RadioGroup = RadioGroup;
Form.RadioGroupItem = RadioGroupItem;
Form.Group = Group;
Form.Textarea = Textarea;
Form.Divider = Divider;
Form.Title = Title;
Form.TagsInput = TagsInput;
Form.CheckboxGroup = CheckboxGroup;
Form.Checkbox = Checkbox;
